import SubHeader from "../components/Subheader";
import DisplayAndPlayIntervals from "../EARTRAINING/DisplayAndPlayIntervals"

const EarTrainingPage = () => {
  return (
    <div>
      <SubHeader current="Ear Training" />
      <DisplayAndPlayIntervals />
    </div>
  );
};

export default EarTrainingPage;
